<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
</div>
<div class="date-filter">
  <div class="grid">
    <div *ngIf="isFilterVisible('startDate')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="startDate">Start Date</label>
        <div class="custom-select2 custom-date-calender">
          <p-calendar #calendarTopStartDateRef id="startDate" dateFormat="M dd, yy" [inputStyle]="{'width':'95%'}" inputId="startDateInput"
          [appEnterKeyListener]="'start'" (keydown.enter)="getRoleBasedSearchFunction('search')"
            placeholder="Select Date" [(ngModel)]="startDate"></p-calendar><img
            [calendarOpener]="calendarTopStartDateRef" src="assets/images/date-calender.png" alt="calender"/>
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('endDate')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="endDate">End Date</label>
        <div class="custom-select2 custom-date-calender">
          <p-calendar #calendarTopEndDateRef id="endDate" dateFormat="M dd, yy" [inputStyle]="{'width':'95%'}" inputId="endDateInput"
          [appEnterKeyListener]="'end'" (keydown.enter)="getRoleBasedSearchFunction('search')"
            placeholder="Select Date" [(ngModel)]="endDate"></p-calendar><img [calendarOpener]="calendarTopEndDateRef"
            src="assets/images/date-calender.png" alt="calender" />
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('name')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="name">Name</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input type="text" id="name" pInputText placeholder="Enter Name" [(ngModel)]="name" (keydown.enter)="getRoleBasedSearchFunction('search')"/>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('phoneNumber')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="mobile">Mobile Number</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input type="text" id="mobile" pInputText placeholder="Enter Mobile Number" [(ngModel)]="phoneNumber"
              (keypress)="onlyNumber($event)" (keydown.enter)="getRoleBasedSearchFunction('search')" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('email')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="email">Email</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="email" type="text" pInputText placeholder="Enter Email" [(ngModel)]="email" (keydown.enter)="getRoleBasedSearchFunction('search')" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('paymentStatus')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="paymentStatus">Payment Status</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <p-dropdown id="paymentStatus" [options]="selectStatus" (onChange)="onChangePaymentStatus($event)" placeholder="Select Status"
              [(ngModel)]="searchStatus" optionLabel="name" optionValue="id" optionValue="value"></p-dropdown>
            <img src="../../../../assets/images/fill-dropdown.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isFilterVisible('invoiceNumber')" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="invoiceNumber">Invoice Number</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input type="text" pInputText id="invoiceNumber" placeholder="Enter Invoice Number" [(ngModel)]="invoiceNumber" (keydown.enter)="getRoleBasedSearchFunction('search')"/>
          </div>
        </div>
      </div>
    </div>

<div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer">
          <p-button styleClass="p-button search-button" label="Search"
            (onClick)="role === 'Driver' || role === 'GroupUser' ? checkDataTimeValidation() : getInvoiceListBookings('search')"></p-button>
        </div>
      </div>
    </div>

<div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer reset-btn">
          <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="driver-list-outer">
  <div class="list-heading">
    <h4 *ngIf="isDriverOrGroupUser">Booking Invoices</h4>
    <h4 *ngIf="isAdminOrOwnerRole">Invoice List - Booking Invoices</h4>
    <div class="record-outer">
      <div class="page-list filter-parking record-inner">
        <div class="records-outer"><span>Show</span>
          <div class="records-inner"> <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)"
              placeholder="10" optionLabel="name" optionValue="value"
              [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img src="assets/images/fill-dropdown.svg" alt=""/>
          </div>
          <span>Records</span>
        </div>

<div *ngIf="isAdminOrOwnerRole" (click)="exportMenu();menu.toggle($event)" class="three-dots">
          <img src="assets/images/dashboard-dot.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="card parking-list fullwidth-table-scroll common-heighttd booking-outer"
    [class.parking-list]="invoiceList?.length>0">

    <p-table id="tbl-top" [value]="invoiceList" [resizableColumns]="true" columnResizeMode="expand">
      <ng-template pTemplate="header">
        <tr>
            <th scope="col" *ngIf="isDriverOrGroupUser">Parking Lot</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole" class="custom-addres">Name</th>
            <th scope="col">Invoice Number</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">Email</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">Mobile Number</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">User Type</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">Company</th>
            <th scope="col"  *ngIf="isAdminOrOwnerRole" class="invoice-lots">Parking Lot</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">Generated By</th>
            <th scope="col">Booking Type</th> 
            <th scope="col">Arrival Date & Time</th>
            <th scope="col">Departure Date & Time</th>
            <th scope="col">Time Zone</th>
            <th scope="col">Created Date & Time</th>
            <th scope="col">Amount ($)</th>
            <th scope="col" *ngIf="!isDriverOrGroupUser">Payment Mode</th>
            <th scope="col">Payment Status</th>
            <th scope="col" *ngIf="isAdminOrOwnerRole">Cancellation Reason</th>
            <th scope="col">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="border12">
          <td *ngIf="isDriverOrGroupUser">
            <div class="custom-name custom-no-pointer">
              <div class="custom-name custom-no-pointer">
                <div class="img-inner custom-no-pointer">
                  <img class="circle-img custom-no-pointer" [src]="(rowData.companyLogo)?rowData.companyLogo:dummy" alt="Company logo"/>
                </div>
                <div class="custom-text">
                  <h5>{{rowData.parkingLotName}}</h5>
                  <p>{{rowData.parkingLotAddress}}</p>
                </div>
              </div>
            </div>
          </td>
          <td *ngIf="isAdminOrOwnerRole" class="driver-name custom-driver-name" (click)="goToCrmPage(rowData)">
            <div class="history-table invoice-list-name">
              <img [src]="rowData.profileImage || 'assets/images/dummy-img.png'" alt="Profile" />
              <p>{{ rowData.userType === 'Group Operator' ? rowData.groupName :
                rowData.name }}</p>
            </div>
          </td>
          <td>{{rowData.invoiceNumber}}</td>
          <td *ngIf="isAdminOrOwnerRole">{{rowData.email}}</td>
          <td *ngIf="isAdminOrOwnerRole">
            <div class="mobile-number"><span *ngIf="rowData?.phoneNumber" [ngClass]="getFlagClass(rowData?.iso)"></span>
              {{ rowData?.phoneNumber ? rowData.countryCode + ' ' + rowData.phoneNumber : '-' }}</div>
          </td>
          <td *ngIf="isAdminOrOwnerRole">{{rowData.userType}}</td>
          <td *ngIf="isAdminOrOwnerRole">{{rowData.companyName}}</td>
          <td *ngIf="isAdminOrOwnerRole">
            <p class="parking-lot-text">{{rowData.parkingLotName}}<br>
              {{rowData.parkingLotAddress}}</p>
          </td>
          <td *ngIf="isAdminOrOwnerRole">{{rowData.generatedBy}}</td>
          <td>{{(rowData.bookingType > 0 || rowData.parentId != null) ? 'Recurring' : 'One Time' }}
            <p *ngIf="rowData.isSubscriptionCancel" class="payment-failed">Recurring Cancelled on
              {{rowData.recurringCancelDate | date:'MMM d, yyyy'}}</p>
            <p class="recurring-active"
              *ngIf="!rowData.isSubscriptionCancel && (rowData.bookingType > 0 || rowData.parentId != null) && (rowData.paymentInfo?.paymentStatus === 2 || rowData.paymentInfo?.paymentStatus === 4 || rowData.paymentInfo?.paymentStatus === 7)">
              Recurring Active</p>
          </td>
          <td>{{rowData.arrivalDate}}</td>
          <td>{{rowData.departureDate}}</td>
          <td>
            <div class="big-parking">
              <p>{{rowData.timeZone ? (getTimeZoneAbbreviation(rowData?.timeZone)) : '-'}}</p>
            </div>
          <td>{{rowData.createdDate}}</td>
          <td class="last-col">{{rowData.amount}}</td>
          <td *ngIf="!isDriverOrGroupUser">{{rowData.bookingPaymentMode | paymentModeValue}}</td>
          <td>
            <div class="big-parking">
              <p class="common-payment-status" [ngClass]="rowData.paymentStatus | invoicePaymentStatus">
                {{rowData.paymentStatusLabel}}
                <span *ngIf="rowData.paymentStatus === invoicePaymentStatus.PaymentFailed">
                  <em class="pi pi-info-circle" [pTooltip]="rowData?.paymentFailureError" tooltipPosition="top">
                  </em>
                </span>
              </p>
            </div>
          </td>
          <td *ngIf="isAdminOrOwnerRole" >
            <div class="custom-text cancellation-reason-outer">
              <em class="pi pi-info-circle" *ngIf="rowData?.cancellationReasonDetail"
                [pTooltip]="rowData?.cancellationReasonDetail" tooltipPosition="top">
            </em>
              <p>{{rowData.cancellationReason || '-'}}</p>

            </div>
          </td>
          <td>
            <div class="export-btn">
              <img *ngIf="isAdminOrOwnerRole || !isAdminOrOwnerRole"
                (click)="activeItem = rowData; isAdminOrOwnerRole ? showData(rowData,$event) : showDataForDriver(rowData); menu.toggle($event)"
                src="assets/images/dashboard-dot.svg" alt="" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-border">
          <td class="no-record" colspan="16">
            No Record Found
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
  <div class="card flex justify-content-end custom-pagination1" *ngIf="invoiceList?.length > 0">
    <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)"></p-paginator>

  </div>
</div>

<div [ngClass]="{'export-btn': !isAlternateDesign, 'custom-export': isAlternateDesign }">
  <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>